// extracted by mini-css-extract-plugin
module.exports = {"aside_background":"AsideBackground_aside_background__361op"};